// 页面相关信息的计算和获取

// 表格宽度
export function getTableInfo(TableData,checkWidth) { // checkWidth为多选框在表格内的宽度
	// 获取页面可视宽度
	let body_width = document.body.clientWidth - 60 // 这个60是两边个30的内边距 
	let table_width = 0 // 表格内容的宽度
	let null_width = 0 // 空提示的宽度
	let check_width = checkWidth || 0
	let nn = 30 + check_width  // 这个30是通过fixed定位在页面最右部盒子的宽度，用来遮挡表格最后部，使表格最右边的内容距离浏览器边框有段距离
	TableData.forEach((res,index)=>{
		// 有的表格里带show_control字段，这里要做区分
		if(res.hasOwnProperty('show_control')){
			if(res.show_control){
				nn = nn + res.width
			}
		}
		else {
			nn = nn + res.width
		}
		
	})
	// 表格宽度小于屏幕的可视宽度减去两边的内边距，并且差距要在100px以上
	if(nn < body_width && body_width - nn > 100){ // 当表格内容不足以沾满一屏时，要适配成一屏
		// console.log("适配")
		TableData.forEach(res=>{ // 针对表格每一项的宽度进行适配
			res.width = Math.round((res.width/nn)*(body_width - check_width)) // 这里减是为了避免res.width值的总和会超过body_width进行的微调，不-10问题应该也不大
		})
		table_width = body_width
	}
	else { // 表格宽度大于等于屏幕可视宽度
		// console.log("不适配")
		table_width = nn
	}
		
	// 表格空提示宽度，以及分页组件的宽度
	if(table_width >= body_width){ 
		null_width = body_width
	}
	else { 
		null_width = table_width
	}
	
	
	return {
		body_width,
		table_width,
		null_width
	}
	
	// 进行适配、统一封装前的代码。
	// 用于开发新页面时，确认表格每一项的宽度，然后再进行适配。
	// that.body_width = document.body.clientWidth - 60 // 筛选条件大盒子的宽度
	// let nn = 0
	// that.rableTitle.forEach((res,index)=>{
	// 	nn = nn + res.width
	// })
	// that.table_scroll_width = nn + 30
	// if(that.table_scroll_width >= that.body_width){ that.table_null_width = that.body_width - 60 }
	// else { that.table_null_width = that.table_scroll_width - 60 }
}

// 当前日期，用于页面日期搜索框
export const getDateInfo = () => { 
	// 获取当前日期
	let this_day
	let date2 = new Date();
	let month2
	if(date2.getMonth() + 1 < 10){
		month2 = '0' + (date2.getMonth() + 1)
	}
	else {
		month2 = date2.getMonth() + 1
	}
	let day2
	if(date2.getDate() < 10){
		day2 = "0" + date2.getDate()
	}
	else {
		day2 = date2.getDate()
	}
	this_day = date2.getFullYear() + "-" + month2 + "-" + day2;
	
	return this_day
}

// 获取今天往前多少天的日期
export const getBeforeDate = (numbers) => { 
	let before_day
	
	let nnn = numbers || 0
	let date1 = new Date(new Date().getTime() - nnn*60*60*24*1000);
	let month1
	if(date1.getMonth() + 1 < 10){
		month1 = '0' + (date1.getMonth() + 1)
	}
	else {
		month1 = date1.getMonth() + 1
	}
	let day1
	if(date1.getDate() < 10){
		day1 = "0" + date1.getDate()
	}
	else {
		day1 = date1.getDate()
	}
	before_day = date1.getFullYear() + "-" + month1 + "-" + day1;
	
	return before_day
}